/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountsPayableAuditLogActivity,
  ApprovalStepActivity,
  ApprovalStepActivityV2,
  CommentActivity,
  CreateInvoiceRequest,
  CreateInvoiceViaInboxPayload,
  DeleteInvoiceRequest,
  EditAllInvoicesFilteredRequest,
  ExportEventActivity,
  ExternalActionActivityV2,
  GetInvoiceRequest,
  GetInvoiceSummaryRequest,
  GetSuggestionsByInvoiceIdWithTextParams,
  InvoiceItemWithPaymentDetailsDto,
  InvoiceSummaryDataExportDto,
  ManuallyForwardActivity,
  PageInvoiceWithPurchaseRequestUsageDecorator,
  PaymentActivity,
  PurchaseRequestSuggestionDto,
  ReviewActionLogDto,
  StatusChangeActivity,
  StatusChangeOfPurchaseRequestActivity,
  SystemActionActivityV2,
  SystemPaymentActionActivityV2,
  UpdateInvoiceToItemsDtoPayload,
  UserActionActivity,
  UserActionActivityV2,
  UserActionOfPurchaseRequestActivity,
  UserFieldChangeActivity,
  VerificationStepActivityV2,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiInvoicesV3Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name UpdateAllInvoicesFilteredToInvoiceDto
   * @request PUT:/api/v3/invoices/
   */
  updateAllInvoicesFilteredToInvoiceDto = (
    data: EditAllInvoicesFilteredRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<InvoiceItemWithPaymentDetailsDto[], any>({
      path: `/v3/invoices/`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateAllInvoicesFilteredToInvoiceDtoPath = '/v3/invoices/'
  static updateAllInvoicesFilteredToInvoiceDtoMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name UpdateInvoiceToItemsDto
   * @request PUT:/api/v3/invoices/INVOICE_ITEM_DTO
   */
  updateInvoiceToItemsDto = (data: UpdateInvoiceToItemsDtoPayload, params: RequestParams = {}) =>
    this.http.request<InvoiceItemWithPaymentDetailsDto[], any>({
      path: `/v3/invoices/INVOICE_ITEM_DTO`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateInvoiceToItemsDtoPath = '/v3/invoices/INVOICE_ITEM_DTO'
  static updateInvoiceToItemsDtoMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name CreateInvoiceAsInvoiceItem
   * @request POST:/api/v3/invoices/INVOICE_ITEM_DTO
   */
  createInvoiceAsInvoiceItem = (data: CreateInvoiceRequest, params: RequestParams = {}) =>
    this.http.request<InvoiceItemWithPaymentDetailsDto, any>({
      path: `/v3/invoices/INVOICE_ITEM_DTO`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static createInvoiceAsInvoiceItemPath = '/v3/invoices/INVOICE_ITEM_DTO'
  static createInvoiceAsInvoiceItemMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetInvoicesSummaryExportDto
   * @request POST:/api/v3/invoices/summary-data/EXPORT
   */
  getInvoicesSummaryExportDto = (data: GetInvoiceSummaryRequest, params: RequestParams = {}) =>
    this.http.request<InvoiceSummaryDataExportDto, any>({
      path: `/v3/invoices/summary-data/EXPORT`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getInvoicesSummaryExportDtoPath = '/v3/invoices/summary-data/EXPORT'
  static getInvoicesSummaryExportDtoMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetPagedInvoiceItemsDto
   * @request POST:/api/v3/invoices/paged
   */
  getPagedInvoiceItemsDto = (data: GetInvoiceRequest, params: RequestParams = {}) =>
    this.http.request<PageInvoiceWithPurchaseRequestUsageDecorator, any>({
      path: `/v3/invoices/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPagedInvoiceItemsDtoPath = '/v3/invoices/paged'
  static getPagedInvoiceItemsDtoMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetInvoiceIdsDto
   * @request POST:/api/v3/invoices/list/IDS
   */
  getInvoiceIdsDto = (data: GetInvoiceRequest, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v3/invoices/list/IDS`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getInvoiceIdsDtoPath = '/v3/invoices/list/IDS'
  static getInvoiceIdsDtoMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name CreateInvoiceViaInbox
   * @request POST:/api/v3/invoices/inbox
   */
  createInvoiceViaInbox = (data: CreateInvoiceViaInboxPayload, params: RequestParams = {}) =>
    this.http.request<InvoiceItemWithPaymentDetailsDto, any>({
      path: `/v3/invoices/inbox`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static createInvoiceViaInboxPath = '/v3/invoices/inbox'
  static createInvoiceViaInboxMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetInvoiceItemDto
   * @request GET:/api/v3/invoices/{invoiceId}
   */
  getInvoiceItemDto = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<InvoiceItemWithPaymentDetailsDto, any>({
      path: `/v3/invoices/${invoiceId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInvoiceItemDtoPath = '/v3/invoices/${invoiceId}'
  static getInvoiceItemDtoMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetSuggestionsByInvoiceId
   * @request GET:/api/v3/invoices/{invoiceId}/suggestions
   */
  getSuggestionsByInvoiceId = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<PurchaseRequestSuggestionDto[], any>({
      path: `/v3/invoices/${invoiceId}/suggestions`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSuggestionsByInvoiceIdPath = '/v3/invoices/${invoiceId}/suggestions'
  static getSuggestionsByInvoiceIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetSuggestionsByInvoiceIdWithText
   * @request GET:/api/v3/invoices/{invoiceId}/suggestionsWithText
   */
  getSuggestionsByInvoiceIdWithText = (
    { invoiceId, ...query }: GetSuggestionsByInvoiceIdWithTextParams,
    params: RequestParams = {},
  ) =>
    this.http.request<PurchaseRequestSuggestionDto[], any>({
      path: `/v3/invoices/${invoiceId}/suggestionsWithText`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getSuggestionsByInvoiceIdWithTextPath = '/v3/invoices/${invoiceId}/suggestionsWithText'
  static getSuggestionsByInvoiceIdWithTextMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetLastReviewActionLog
   * @request GET:/api/v3/invoices/{invoiceId}/lastReviewAction
   */
  getLastReviewActionLog = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<ReviewActionLogDto, any>({
      path: `/v3/invoices/${invoiceId}/lastReviewAction`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLastReviewActionLogPath = '/v3/invoices/${invoiceId}/lastReviewAction'
  static getLastReviewActionLogMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name GetInvoiceActivities
   * @request GET:/api/v3/invoices/{invoiceId}/activities
   */
  getInvoiceActivities = (invoiceId: string, params: RequestParams = {}) =>
    this.http.request<
      (
        | AccountsPayableAuditLogActivity
        | ApprovalStepActivity
        | ApprovalStepActivityV2
        | CommentActivity
        | ExportEventActivity
        | ExternalActionActivityV2
        | ManuallyForwardActivity
        | PaymentActivity
        | StatusChangeActivity
        | StatusChangeOfPurchaseRequestActivity
        | SystemActionActivityV2
        | SystemPaymentActionActivityV2
        | UserActionActivity
        | UserActionActivityV2
        | UserActionOfPurchaseRequestActivity
        | UserFieldChangeActivity
        | VerificationStepActivityV2
      )[],
      any
    >({
      path: `/v3/invoices/${invoiceId}/activities`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getInvoiceActivitiesPath = '/v3/invoices/${invoiceId}/activities'
  static getInvoiceActivitiesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invoices-v-3-controller
   * @name DeleteInvoices
   * @request DELETE:/api/v3/invoices
   */
  deleteInvoices = (data: DeleteInvoiceRequest, params: RequestParams = {}) =>
    this.http.request<object, any>({
      path: `/v3/invoices`,
      method: 'DELETE',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static deleteInvoicesPath = '/v3/invoices'
  static deleteInvoicesMethod = 'DELETE'
}
